import { Navigate, Outlet } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useAuth } from "../context/AuthContext";
import { useSettings } from "../context/SettingsContext";

export function RequireAuth() {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
        <CircularProgress />
      </Box>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}

export function RequireAdmin() {
  const { isAdmin } = useAuth();
  if (!isAdmin) return <Navigate to="/panel" replace />;
  return <Outlet />;
}

// Admin siempre entra; recepción solo si el administrador habilitó
// "Permitir que recepción gestione reservaciones" en Ajustes. Espera a
// que los ajustes terminen de cargar antes de decidir — si no, un
// recepcionista con el permiso SÍ activado sería expulsado por error
// durante el instante en que `settings` todavía es null.
export function RequireBookingAccess() {
  const { isAdmin } = useAuth();
  const { settings, ready } = useSettings();
  if (!isAdmin && !ready) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
        <CircularProgress />
      </Box>
    );
  }
  if (!isAdmin && !settings?.allowRecepcionistaBookings) return <Navigate to="/panel" replace />;
  return <Outlet />;
}
